import { Icon } from './Icons'

export function IconButton({
  type,
  children,
  buttonClass = 'neutral',
  iconClass = '',
  className = 'flex-items gh2 nowrap',
  ...props
}) {
  // note: splitting className and buttonClass so you can leave the default
  // className items and only set the button class as that's the most common
  // use case.
  return (
    <button className={className + ' ' + buttonClass} {...props}>
      <Icon type={type} className={iconClass} />
      {children}
    </button>
  )
}
